export const ScreenTypes = {
  DESKTOP: "desktop",
  MOBILE: "mobile",
};
